// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"fac8ecf9","142":"632364ea","206":"4e29cc78","335":"65544b75","377":"e87e1a9f","641":"ab73bdfe","815":"2c3eda93","974":"7d7490a8"}[chunkId] + ".chunk.js";
};